import { decompressDocument } from "./documentCompression";

export const getDocumentMetadata = (doc) => {
  if (!doc) return { name: "Document", url: "", blobUrl: "", isPdf: false };

  let rawUrl = typeof doc === "string" ? doc : doc.url || doc.data || doc.src || doc.file || "";
  let name = typeof doc === "object" ? doc.name || doc.fileName || doc.title : "";

  if (!name && typeof doc === "string") {
    const filename = doc.split("/").pop().split("?")[0];
    if (filename && filename.includes(".")) {
      name = filename;
    }
  }
  if (!name) name = "Attached_Document.pdf";

  let formattedUrl = rawUrl;

  // Handle relative backend URLs (e.g. /media/...)
  if (rawUrl && rawUrl.startsWith("/") && !rawUrl.startsWith("//")) {
    const backendHost = window.location.hostname === 'localhost' ? 'http://localhost:8000' : window.location.origin;
    formattedUrl = `${backendHost}${rawUrl}`;
  } else if (rawUrl && rawUrl.startsWith("JVBERi")) {
    formattedUrl = `data:application/pdf;base64,${rawUrl}`;
  } else if (
    rawUrl &&
    !rawUrl.startsWith("http://") &&
    !rawUrl.startsWith("https://") &&
    !rawUrl.startsWith("data:") &&
    !rawUrl.startsWith("blob:")
  ) {
    const mime = name.toLowerCase().endsWith(".pdf") ? "application/pdf" : "application/octet-stream";
    formattedUrl = `data:${mime};base64,${rawUrl}`;
  }

  // Decompress pako gzip if needed and create clean Blob URL
  let blobUrl = formattedUrl;
  if (formattedUrl.startsWith("data:")) {
    try {
      const base64Part = formattedUrl.includes(",") ? formattedUrl.split(",")[1] : formattedUrl;
      let pdfBytes;
      try {
        pdfBytes = decompressDocument(base64Part);
      } catch (decompErr) {
        const binaryString = window.atob(base64Part);
        const len = binaryString.length;
        pdfBytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          pdfBytes[i] = binaryString.charCodeAt(i);
        }
      }
      const mimeType = name.toLowerCase().endsWith(".pdf") ? "application/pdf" : "application/octet-stream";
      const blob = new Blob([pdfBytes], { type: mimeType });
      blobUrl = URL.createObjectURL(blob);
    } catch (e) {
      console.error("Error creating document Blob URL:", e);
      blobUrl = formattedUrl;
    }
  }

  const isPdf = name.toLowerCase().endsWith(".pdf") || formattedUrl.includes("application/pdf") || (typeof doc === "string" && doc.toLowerCase().includes(".pdf"));

  return {
    name,
    url: formattedUrl,
    blobUrl,
    isPdf,
  };
};

/**
 * Trigger robust file download for base64 / blob / http URLs
 */
export const downloadDocument = (doc) => {
  const { name, url, blobUrl } = getDocumentMetadata(doc);
  const targetUrl = blobUrl || url;

  if (!targetUrl) return;

  const a = document.createElement("a");
  a.href = targetUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
